export const ChatDisableModal = {
  titles: {
    notShared: "Your chat is currently disabled",
    default: "Chat is disabled",
  },
  bodies: {
    deleted: "Your profile might have been deleted. Please contact support for assistance.",
    notShared: "Enable chat by sharing your profile with attendees in your privacy settings. Changes may take a few minutes to apply.",
    default: "Chat is disabled for users! Please enable share for users.",
  },
};